<template>
	<div class="all">
		<div class="dibu">
			<div class="dibuall">
				<div class="dibuallD">
					<div class="dibu1">
						<div class="dibu11">公司地址</div>
						<div class="dibu12">{{ this.jichuxinxi.address }}</div>
						<!-- <div class="dibu12">峨眉山路</div>
            <div class="dibu12">光谷软件2号楼</div>
            <div class="dibu12">904室</div> -->
					</div>
					<div class="dibu2">
						<div class="dibu11">联系方式</div>
						<div class="dibu12">Tal：{{ this.jichuxinxi.phone }}</div>
						<div class="dibu12">Fax：{{ this.jichuxinxi.contact }}</div>
						<div class="dibu12">Email：{{ this.jichuxinxi.email }}</div>
					</div>
				</div>

				<div class="dibu3">
					<textarea placeholder="留言内容" id="area"></textarea>
					<div class="dibu31">
						<input placeholder="姓名" id="name" />
						<input class="dibu32" placeholder="邮箱" id="email" />
					</div>
					<div class="dibu33" @click="fasong">
						<img src="../assets/fuwuimg/icon_fsxx.png" />
						<div class="dibu331">发送消息</div>
					</div>
				</div>
			</div>
		</div>
		<div class="zuihou">
			<div class="zuihou1">Copyright © 2018 青岛博软网络科技有限公司 版权所有 | 鲁ICP备19004722号-2</div>
		</div>
	</div>
</template>

<script>
	import {
		Message
	} from "element-ui";
	export default {
		data() {
			return {
				jichuxinxi: "",
			};
		},
		// html加载完成之前
		created() {},
		// html加载完成后执行。
		mounted() {
			this.$get(this.$host + "/index/Home/getBaseInfo").then((res) => {
				console.log("基础信息", res);
				this.jichuxinxi = res.data;
			});
		},
		// 事件方法执行
		methods: {
			fasong() {
				console.log(document.getElementById("area").value);
				if (document.getElementById("name").value == undefined || document.getElementById("name").value == '') {
					Message.error({
						message: "姓名不能为空！",
					});
					return false
				}
				if (document.getElementById("area").value == undefined || document.getElementById("area").value == '') {
					Message.error({
						message: "留言不能为空！",
					});
					return false
				}
				if (document.getElementById("email").value == undefined || document.getElementById("email").value == '') {
					Message.error({
						message: "邮箱不能为空！",
					});
					return false
				}
				var reg1 = new RegExp("^\\w+@\\w{2,6}(\\.\\w{2,3})+$", "i");
				if (reg1.test(document.getElementById("email").value)) {
					// alert("2")
				} else {
					Message.error({
						message: "请输入正确的邮箱！",
					});
					return false
				}

				let formData = new FormData();
				var that = this;
				formData.append("contactor", document.getElementById("name").value);
				formData.append("content", document.getElementById("area").value);
				formData.append("email", document.getElementById("email").value);
				this.$post(this.$host + "/index/Message/sendMessage", formData).then(
					(res) => {
						console.log("res", res);
						document.getElementById("name").value = "";
						document.getElementById("area").value = "";
						document.getElementById("email").value = "";
						if (res.code == 500) {
							Message.error({
								message: res.msg,
							});
						} else {
							Message.success({
								message: res.msg,
							});
						}
					}
				);
			},
		},
		// 计算属性
		computed: {},
		// 侦听器
		watch: {},
	};
</script>

<style lang="scss" scoped>
	.dibu {
		background-image: url("../assets/chenggong/bg_dz.png");
		width: 100%;
		height: 600px;
		background-size: 100% 100%;
		left: 0;
		right: 0;
		margin: auto;

		.dibuall {
			display: flex;
			justify-content: center;
			.dibuallD{
				
			}
			.dibu1 {
				// margin-left: 302px;
				margin-top: 71px;

				// top: 71px;
				.dibu11 {
					font-size: 24px;
					color: white;
					margin-bottom: 20px;
				}

				.dibu12 {
					width: 110px;
					line-height: 40px;
					font-size: 18px;
					color: grey;
					margin-bottom: 20px;
				}
			}

			.dibu2 {
				// margin-left: 302px;
				// margin-top: 350px;
				// top: 71px;
				.dibu11 {
					font-size: 24px;
					color: white;
					margin-bottom: 20px;
				}

				.dibu12 {
					font-size: 18px;
					color: grey;
					margin-bottom: 20px;
				}
			}

			.dibu3 {
				margin-left: 105px;
				margin-top: 70px;

				textarea {
					-web-kit-appearance: none;
					-moz-appearance: none;
					resize: none;
					border: 1px solid #a0a0a0;
					border-radius: 3px;
					font-size: 18px;
					color: #e6eaf0;
					outline: none;
					width: 50vw;
					height: 260px;
					background: rgba(153, 205, 50, 0);
					padding: 20px;
				}

				input {
					// -web-kit-appearance: none;
					// -moz-appearance: none;
					resize: none;
					border: 1px solid #a0a0a0;
					border-radius: 3px;
					color: #e6eaf0;
					font-size: 18px;
					// outline: none;
					width: 22vw;
					height: 60px;
					background: rgba(153, 205, 50, 0);
					padding: 20px;
					margin-top: 20px;
				}

				.dibu32 {
					margin-left: 6vw;
				}

				.dibu33 {
					width: 200px;
					height: 80px;
					background: #126CE7;
					margin-right: 0px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-top: 20px;
					margin-left: 39.2vw;
					cursor: pointer;

					img {
						widows: 40px;
						height: 40px;
					}

					.dibu331 {
						font-size: 18px;
						color: #ffffff;
					}
				}
			}
		}
	}

	.zuihou {
		width: 100%;
		height: 52px;
		background: black;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 20px;

		.zuihou2 {
			margin-left: 40px;
		}
	}
</style>
